import { render, staticRenderFns } from "./DetailCardTableComponent.vue?vue&type=template&id=3ab4b631"
import script from "./DetailCardTableComponent.vue?vue&type=script&lang=js"
export * from "./DetailCardTableComponent.vue?vue&type=script&lang=js"
import style0 from "./DetailCardTableComponent.vue?vue&type=style&index=0&id=3ab4b631&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports